import React, { useRef } from "react";
import { useAppDispatch } from "../../app/hooks";
import {
  deleteWithdrawlRequest,
  getWalletWithdrawalHistory,
} from "./services/wallet.services";
import { useNavigate } from "react-router";

const WalletWithdrawReqDelete = ({ ID, isfromHistory = false }: any) => {
  const deleteCloseBtnRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleDeleteWithdrawalReq = async () => {
    if (ID) {
      const response = await dispatch(deleteWithdrawlRequest(ID));
      if (response.meta.requestStatus === "fulfilled") {
        if (isfromHistory) {
          dispatch(getWalletWithdrawalHistory());
        } else {
          navigate("/walletwithdrawalhistory");
        }
        if (deleteCloseBtnRef.current) {
          deleteCloseBtnRef.current.click();
        }
      }
    }
  };

  return (
    <div
      className="modal fade"
      id="withdrawalrequestdelete"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="edit-profile"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: 350 }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title fs-5" id="edit-profile">
              Delete Withdrawal Request
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body travel-form-detail">
            <div className="travel-form">
              <p>Are you want to sure to delete it?</p>
            </div>
            <div className="travel-detail-btns mt-4">
              <button
                className="cancel-btn"
                data-bs-dismiss="modal"
                ref={deleteCloseBtnRef}
              >
                Cancel
              </button>
              <button
                className="submit-btn"
                onClick={() => handleDeleteWithdrawalReq()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletWithdrawReqDelete;
